export default {
  u: '',
  m: 'Мужской',
  f: 'Женский'
}
